import { RolePermissionKey } from '@/modules/ta/role/role.constants';
import { Module } from '@/modules/core/app/constants/app.constants';

export class AppModule {
  static getAppPermissionKeysForModule(module) {
    switch (module) {
      case Module.ALERT:
      case Module.CLIENTGROUP:
      case Module.CLUSTER:
      case Module.DASHBOARD:
      case Module.DESIGN:
      case Module.ENDCUSTOMER:
      case Module.DASHBOARDEXECUTIVESUMMARIES:
      case Module.GOAL:
      case Module.LEAD:
      case Module.LEADDETAILS:
      case Module.LEADNOTES:
      case Module.LEADNOTIFICATION:
      case Module.PREFERENCE:
      case Module.QUICKREPORT:
      case Module.REPORTINGPROFILE:
      case Module.REPORTINGTEMPLATE:
      case Module.REPORTSTUDIO:
      case Module.REPORTSTUDIOEXECUTIVESUMMARIES:
      case Module.ROLE:
      case Module.SCHEDULEDREPORT:
      case Module.CUSTOMTRANSLATION:
      case Module.WEBHOOKS:
      case Module.WIDGET:
        return [RolePermissionKey.CAN_ACCESS_RIPLEY];
      case Module.COMPETITORRESEARCH:
      case Module.KEYWORDTRACKING:
      case Module.WEBSITE:
      case Module.SEO:
      case Module.SERP:
      case Module.SITEAUDITOR:
        return [RolePermissionKey.CAN_ACCESS_ZEST];
      case Module.CAMPAIGN:
      case Module.CATEGORY:
      case Module.CATEGORYDATA:
      case Module.CONNECTIONSTATUS:
      case Module.DATALOADSTATUS:
      case Module.DATAEXPORTER:
      case Module.DATASOURCE:
      case Module.CLIENT:
      case Module.IMPORTWIZARD:
      case Module.MARGINRULE:
      case Module.NAMINGCONVENTION:
      case Module.SERVICE:
      case Module.SERVICESETTINGS:
      case Module.SERVICECLIENTMAPPING:
      case Module.SERVICELOOKUP:
      case Module.SMARTCAMPAIGN:
        return [
          RolePermissionKey.CAN_ACCESS_ACORN,
          RolePermissionKey.CAN_ACCESS_RIPLEY,
          RolePermissionKey.CAN_ACCESS_SHEETS,
          RolePermissionKey.CAN_ACCESS_GDS,
        ];
      case Module.SHEETS:
        return [RolePermissionKey.CAN_ACCESS_SHEETS];
      case Module.GDS:
        return [RolePermissionKey.CAN_ACCESS_GDS];
      default:
        return null;
    }
  }
}
